import { render, staticRenderFns } from "./ExchangeHistory.vue?vue&type=template&id=c9896c18&scoped=true"
import script from "./ExchangeHistory.vue?vue&type=script&lang=js"
export * from "./ExchangeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9896c18",
  null
  
)

export default component.exports